export var preventDefault = function (callback) { return function (e) {
    e.preventDefault();
    callback && callback(e);
}; };
//# sourceMappingURL=prevent-default.js.map